























import { pick } from "lodash-es";
import Vue from "vue";

export default Vue.extend({
  name: "TipsContinue",
  data() {
    return {};
  },
  computed: {
    routeHere() {
      return {
        name: "kyc",
        hash: "#continue",
        params: this.$route.params,
        query: pick(this.$route.query, ["role", "code", "remote"])
      };
    }
  },
  components: {},
  methods: {}
});
